export const icons = {"accountDetailsFilled":"account-details-filled.svg","accountDetails":"account-details.svg","addPictureFilled":"add-picture-filled.svg","addPicture":"add-picture.svg","airConditioningFilled":"air-conditioning-filled.svg","airConditioning":"air-conditioning.svg","airportFilled":"airport-filled.svg","airport":"airport.svg","androidFilled":"android-filled.svg","android":"android.svg","antiqueFilled":"antique-filled.svg","antique":"antique.svg","arrowLeftCircleFilled":"arrow-left-circle-filled.svg","arrowLeftCircle":"arrow-left-circle.svg","arrowLeftFilled":"arrow-left-filled.svg","arrowLeft":"arrow-left.svg","arrowRightCircleFilled":"arrow-right-circle-filled.svg","arrowRightCircle":"arrow-right-circle.svg","arrowRightFilled":"arrow-right-filled.svg","arrowRight":"arrow-right.svg","audioInputFilled":"audio-input-filled.svg","audioInput":"audio-input.svg","babySeatFilled":"baby-seat-filled.svg","babySeat":"baby-seat.svg","backupCameraFilled":"backup-camera-filled.svg","backupCamera":"backup-camera.svg","bankFilled":"bank-filled.svg","bank":"bank.svg","batteryFilled":"battery-filled.svg","battery":"battery.svg","bedFilled":"bed-filled.svg","bed":"bed.svg","bellFilled":"bell-filled.svg","bell":"bell.svg","bikeRackFilled":"bike-rack-filled.svg","bikeRack":"bike-rack.svg","binFilled":"bin-filled.svg","bin":"bin.svg","bluetoothFilled":"bluetooth-filled.svg","bluetooth":"bluetooth.svg","briefcase":"briefcase.svg","bulbFilled":"bulb-filled.svg","bulb":"bulb.svg","cableFilled":"cable-filled.svg","cable":"cable.svg","cabrioletFilled":"cabriolet-filled.svg","cabriolet":"cabriolet.svg","calendarCheckFilled":"calendar-check-filled.svg","calendarCheck":"calendar-check.svg","calendarClockFilled":"calendar-clock-filled.svg","calendarClock":"calendar-clock.svg","calendarDeleteFilled":"calendar-delete-filled.svg","calendarDelete":"calendar-delete.svg","calendarEndFilled":"calendar-end-filled.svg","calendarEnd":"calendar-end.svg","calendarFilled":"calendar-filled.svg","calendarStartFilled":"calendar-start-filled.svg","calendarStart":"calendar-start.svg","calendar":"calendar.svg","cameraAddFilled":"camera-add-filled.svg","cameraAdd":"camera-add.svg","cameraFilled":"camera-filled.svg","camera":"camera.svg","campervanFilled":"campervan-filled.svg","campervan":"campervan.svg","capacityFilled":"capacity-filled.svg","capacity":"capacity.svg","carAddFilled":"car-add-filled.svg","carAdd":"car-add.svg","carCheckFilled":"car-check-filled.svg","carCheck":"car-check.svg","carDamagesFilled":"car-damages-filled.svg","carDamages":"car-damages.svg","carDeleteFilled":"car-delete-filled.svg","carDelete":"car-delete.svg","carDrivyOpen":"car-drivy-open.svg","carFilled":"car-filled.svg","carGroupFilled":"car-group-filled.svg","carGroup":"car-group.svg","carLockFilled":"car-lock-filled.svg","carLock":"car-lock.svg","carPlayFilled":"car-play-filled.svg","carPlay":"car-play.svg","carReturnFilled":"car-return-filled.svg","carReturn":"car-return.svg","carSearch":"car-search.svg","carTypeAntique":"car-type-antique.svg","carTypeCabriolet":"car-type-cabriolet.svg","carTypeCampervan":"car-type-campervan.svg","carTypeCity":"car-type-city.svg","carTypeConvertible":"car-type-convertible.svg","carTypeCoupe":"car-type-coupe.svg","carTypeFamily":"car-type-family.svg","carTypeFourFour":"car-type-four-four.svg","carTypeMinibus":"car-type-minibus.svg","carTypeSedan":"car-type-sedan.svg","carTypeUtility":"car-type-utility.svg","car":"car.svg","cardFilled":"card-filled.svg","card":"card.svg","cdPlayerFilled":"cd-player-filled.svg","cdPlayer":"cd-player.svg","certificateFilled":"certificate-filled.svg","certificate":"certificate.svg","chainsFilled":"chains-filled.svg","chains":"chains.svg","checkCircleFilled":"check-circle-filled.svg","checkCircle":"check-circle.svg","checkFilled":"check-filled.svg","check":"check.svg","checklistFilled":"checklist-filled.svg","checklist":"checklist.svg","chevronDownFilled":"chevron-down-filled.svg","chevronDown":"chevron-down.svg","chevronLeftFilled":"chevron-left-filled.svg","chevronLeft":"chevron-left.svg","chevronRightFilled":"chevron-right-filled.svg","chevronRight":"chevron-right.svg","chevronUpFilled":"chevron-up-filled.svg","chevronUp":"chevron-up.svg","circledArrowLeft":"circled-arrow-left.svg","circledArrowRight":"circled-arrow-right.svg","cityFilled":"city-filled.svg","city":"city.svg","cleaningFilled":"cleaning-filled.svg","cleaning":"cleaning.svg","clockAlertFilled":"clock-alert-filled.svg","clockAlert":"clock-alert.svg","clockBackwardsFilled":"clock-backwards-filled.svg","clockBackwards":"clock-backwards.svg","clockFilled":"clock-filled.svg","clockForwardsFilled":"clock-forwards-filled.svg","clockForwards":"clock-forwards.svg","clock":"clock.svg","closeCircleFilled":"close-circle-filled.svg","closeCircle":"close-circle.svg","closeFilled":"close-filled.svg","close":"close.svg","collapseFilled":"collapse-filled.svg","collapse":"collapse.svg","connectBoxFilled":"connect-box-filled.svg","connectBox":"connect-box.svg","connectCarFilled":"connect-car-filled.svg","connectCar":"connect-car.svg","contactMail":"contact-mail.svg","contactPhone":"contact-phone.svg","contextualPaperclip":"contextual-paperclip.svg","contextualQuestion":"contextual-question.svg","contextualWarningCircleFilled":"contextual-warning-circle-filled.svg","contextualWarningCircle":"contextual-warning-circle.svg","contract":"contract.svg","convertibleFilled":"convertible-filled.svg","convertible":"convertible.svg","copyFilled":"copy-filled.svg","copy":"copy.svg","coupeFilled":"coupe-filled.svg","coupe":"coupe.svg","creditCardAddFilled":"credit-card-add-filled.svg","creditCardAdd":"credit-card-add.svg","creditCardErrorFilled":"credit-card-error-filled.svg","creditCardError":"credit-card-error.svg","creditCardFilled":"credit-card-filled.svg","creditCard":"credit-card.svg","crosshover":"crosshover.svg","crossoverFilled":"crossover-filled.svg","crossover":"crossover.svg","cruiseControlFilled":"cruise-control-filled.svg","cruiseControl":"cruise-control.svg","currencyFilled":"currency-filled.svg","currency":"currency.svg","dashcamFilled":"dashcam-filled.svg","dashcam":"dashcam.svg","diamondFilled":"diamond-filled.svg","diamond":"diamond.svg","directionsFilled":"directions-filled.svg","directions":"directions.svg","document":"document.svg","dotHorizontalFilled":"dot-horizontal-filled.svg","dotHorizontal":"dot-horizontal.svg","dotVerticalFilled":"dot-vertical-filled.svg","dotVertical":"dot-vertical.svg","dotsHorizontal":"dots-horizontal.svg","dotsVertical":"dots-vertical.svg","downloadFilled":"download-filled.svg","download":"download.svg","earningFilled":"earning-filled.svg","earning":"earning.svg","earthFilled":"earth-filled.svg","earth":"earth.svg","edit":"edit.svg","electricFilled":"electric-filled.svg","electric":"electric.svg","evBatteryFilled":"ev-battery-filled.svg","evBattery":"ev-battery.svg","evCableFilled":"ev-cable-filled.svg","evCable":"ev-cable.svg","evChargerFilled":"ev-charger-filled.svg","evCharger":"ev-charger.svg","expandFilled":"expand-filled.svg","expand":"expand.svg","externalLinkFilled":"external-link-filled.svg","externalLink":"external-link.svg","eyeClosedFilled":"eye-closed-filled.svg","eyeClosed":"eye-closed.svg","eyeOpenedFilled":"eye-opened-filled.svg","eyeOpened":"eye-opened.svg","eye":"eye.svg","faceRecognitionFilled":"face-recognition-filled.svg","faceRecognition":"face-recognition.svg","facebook":"facebook.svg","familyFilled":"family-filled.svg","family":"family.svg","fileFilled":"file-filled.svg","file":"file.svg","filepdfFilled":"filepdf-filled.svg","filepdf":"filepdf.svg","filexlsFilled":"filexls-filled.svg","filexls":"filexls.svg","filterFilled":"filter-filled.svg","filter":"filter.svg","filters":"filters.svg","fireFilled":"fire-filled.svg","fire":"fire.svg","flagFilled":"flag-filled.svg","flag":"flag.svg","fourByFourFilled":"four-by-four-filled.svg","fourByFour":"four-by-four.svg","fourWheelDriveFilled":"four-wheel-drive-filled.svg","fourWheelDrive":"four-wheel-drive.svg","fuelTankFilled":"fuel-tank-filled.svg","fuelTank":"fuel-tank.svg","geolocation":"geolocation.svg","giftFilled":"gift-filled.svg","gift":"gift.svg","gpsFilled":"gps-filled.svg","gps":"gps.svg","graphUpFilled":"graph-up-filled.svg","graphUp":"graph-up.svg","handDollarFilled":"hand-dollar-filled.svg","handDollar":"hand-dollar.svg","healingFilled":"healing-filled.svg","healing":"healing.svg","heartFilled":"heart-filled.svg","heart":"heart.svg","heightFilled":"height-filled.svg","height":"height.svg","hitchFilled":"hitch-filled.svg","hitch":"hitch.svg","homeFilled":"home-filled.svg","home":"home.svg","idCardFilled":"id-card-filled.svg","idCard":"id-card.svg","incidentFilled":"incident-filled.svg","incident":"incident.svg","infoCircleFilled":"info-circle-filled.svg","infoCircle":"info-circle.svg","infoFilled":"info-filled.svg","info":"info.svg","instagram":"instagram.svg","instantFilled":"instant-filled.svg","instant":"instant.svg","invoiceFilled":"invoice-filled.svg","invoice":"invoice.svg","keyConnectFilled":"key-connect-filled.svg","keyConnect":"key-connect.svg","keyFilled":"key-filled.svg","key":"key.svg","licenceCheckFilled":"licence-check-filled.svg","licenceCheck":"licence-check.svg","licenceFilled":"licence-filled.svg","licencePaperFilled":"licence-paper-filled.svg","licencePaper":"licence-paper.svg","licence":"licence.svg","lifeBuoyFilled":"life-buoy-filled.svg","lifeBuoy":"life-buoy.svg","linkedin":"linkedin.svg","loading":"loading.svg","localityFilled":"locality-filled.svg","locality":"locality.svg","locationFilled":"location-filled.svg","locationMap":"location-map.svg","locationParking":"location-parking.svg","locationPin":"location-pin.svg","location":"location.svg","lockCheckFilled":"lock-check-filled.svg","lockCheck":"lock-check.svg","lockedFilled":"locked-filled.svg","locked":"locked.svg","loginFilled":"login-filled.svg","login":"login.svg","logoutFilled":"logout-filled.svg","logout":"logout.svg","lookFilled":"look-filled.svg","look":"look.svg","mailCheckFilled":"mail-check-filled.svg","mailCheck":"mail-check.svg","mailFilled":"mail-filled.svg","mail":"mail.svg","mapAltFilled":"map-alt-filled.svg","mapAlt":"map-alt.svg","mapFilled":"map-filled.svg","map":"map.svg","meetDriverFilled":"meet-driver-filled.svg","meetDriver":"meet-driver.svg","meetOwnerFilled":"meet-owner-filled.svg","meetOwner":"meet-owner.svg","menuListFilled":"menu-list-filled.svg","menuList":"menu-list.svg","messagesFilled":"messages-filled.svg","messages":"messages.svg","mileageFilled":"mileage-filled.svg","mileage":"mileage.svg","minibusFilled":"minibus-filled.svg","minibus":"minibus.svg","minusCircleFilled":"minus-circle-filled.svg","minusCircle":"minus-circle.svg","minusFilled":"minus-filled.svg","minus":"minus.svg","miscGift":"misc-gift.svg","moonFilled":"moon-filled.svg","moon":"moon.svg","nearbyDeviceFilled":"nearby-device-filled.svg","nearbyDevice":"nearby-device.svg","notification":"notification.svg","number1CircleFilled":"number-1-circle-filled.svg","number1Circle":"number-1-circle.svg","number2CircleFilled":"number-2-circle-filled.svg","number2Circle":"number-2-circle.svg","number3CircleFilled":"number-3-circle-filled.svg","number3Circle":"number-3-circle.svg","number4CircleFilled":"number-4-circle-filled.svg","number4Circle":"number-4-circle.svg","number5CircleFilled":"number-5-circle-filled.svg","number5Circle":"number-5-circle.svg","okHandFilled":"ok-hand-filled.svg","okHand":"ok-hand.svg","optionAirConditioning":"option-air-conditioning.svg","optionAndroidAuto":"option-android-auto.svg","optionAppleCarplay":"option-apple-carplay.svg","optionAudioInput":"option-audio-input.svg","optionBabySeat":"option-baby-seat.svg","optionBikeRack":"option-bike-rack.svg","optionBluetoothAudio":"option-bluetooth-audio.svg","optionCdPlayer":"option-cd-player.svg","optionChains":"option-chains.svg","optionCruiseControl":"option-cruise-control.svg","optionDashcam":"option-dashcam.svg","optionGps":"option-gps.svg","optionHasTrailer":"option-has-trailer.svg","optionHitch":"option-hitch.svg","optionRoofBox":"option-roof-box.svg","optionSkiRack":"option-ski-rack.svg","optionSnowTire":"option-snow-tire.svg","optionWheelchairAccessible":"option-wheelchair-accessible.svg","paperclipFilled":"paperclip-filled.svg","paperclip":"paperclip.svg","parkingFilled":"parking-filled.svg","parking":"parking.svg","partyFilled":"party-filled.svg","party":"party.svg","passportFilled":"passport-filled.svg","passport":"passport.svg","paymentsFilled":"payments-filled.svg","payments":"payments.svg","pencilFilled":"pencil-filled.svg","pencil":"pencil.svg","peopleUser":"people-user.svg","percentageFilled":"percentage-filled.svg","percentage":"percentage.svg","performanceFilled":"performance-filled.svg","performance":"performance.svg","phoneFilled":"phone-filled.svg","phoneLinkFilled":"phone-link-filled.svg","phoneLink":"phone-link.svg","phone":"phone.svg","photosFilled":"photos-filled.svg","photos":"photos.svg","pickupTruckFilled":"pickup-truck-filled.svg","pickupTruck":"pickup-truck.svg","pigFilled":"pig-filled.svg","pig":"pig.svg","pinFilled":"pin-filled.svg","pin":"pin.svg","plug":"plug.svg","plusCircleFilled":"plus-circle-filled.svg","plusCircle":"plus-circle.svg","plusFilled":"plus-filled.svg","plus":"plus.svg","positionFilled":"position-filled.svg","position":"position.svg","pricingFlatFilled":"pricing-flat-filled.svg","pricingFlat":"pricing-flat.svg","pricingVariableFilled":"pricing-variable-filled.svg","pricingVariable":"pricing-variable.svg","proFilled":"pro-filled.svg","pro":"pro.svg","profilePictureFilled":"profile-picture-filled.svg","profilePicture":"profile-picture.svg","questionCircleFilled":"question-circle-filled.svg","questionCircle":"question-circle.svg","question":"question.svg","raceFlagFilled":"race-flag-filled.svg","raceFlag":"race-flag.svg","radioTuneFilled":"radio-tune-filled.svg","radioTune":"radio-tune.svg","recenterFilled":"recenter-filled.svg","recenter":"recenter.svg","refreshFilled":"refresh-filled.svg","refresh":"refresh.svg","reorderFilled":"reorder-filled.svg","reorder":"reorder.svg","replacementCarFilled":"replacement-car-filled.svg","replacementCar":"replacement-car.svg","replyFilled":"reply-filled.svg","reply":"reply.svg","reset":"reset.svg","rideFilled":"ride-filled.svg","ride":"ride.svg","roadFilled":"road-filled.svg","road":"road.svg","roadsideAssistanceFilled":"roadside-assistance-filled.svg","roadsideAssistance":"roadside-assistance.svg","roofBoxFilled":"roof-box-filled.svg","roofBox":"roof-box.svg","rotateFilled":"rotate-filled.svg","rotate":"rotate.svg","sealCheckFilled":"seal-check-filled.svg","sealCheck":"seal-check.svg","searchCarFilled":"search-car-filled.svg","searchCar":"search-car.svg","searchFilled":"search-filled.svg","searchPeopleFilled":"search-people-filled.svg","searchPeople":"search-people.svg","search":"search.svg","seatbeltFilled":"seatbelt-filled.svg","seatbelt":"seatbelt.svg","sedanFilled":"sedan-filled.svg","sedan":"sedan.svg","sendFilled":"send-filled.svg","send":"send.svg","serviceBattery":"service-battery.svg","serviceCleaning":"service-cleaning.svg","serviceFuel":"service-fuel.svg","serviceHealing":"service-healing.svg","serviceLockedFilled":"service-locked-filled.svg","serviceLocked":"service-locked.svg","serviceTolls":"service-tolls.svg","serviceUnlocked":"service-unlocked.svg","settingsFilled":"settings-filled.svg","settings":"settings.svg","shareAndroidFilled":"share-android-filled.svg","shareAndroid":"share-android.svg","shareIosFilled":"share-ios-filled.svg","shareIos":"share-ios.svg","share":"share.svg","shieldCheckFilled":"shield-check-filled.svg","shieldCheck":"shield-check.svg","shieldFilled":"shield-filled.svg","shield":"shield.svg","shopFilled":"shop-filled.svg","shop":"shop.svg","skiRackFilled":"ski-rack-filled.svg","skiRack":"ski-rack.svg","sliderFilled":"slider-filled.svg","slider":"slider.svg","smartphoneFilled":"smartphone-filled.svg","smartphone":"smartphone.svg","smilingFaceFilled":"smiling-face-filled.svg","smilingFace":"smiling-face.svg","snowTireFilled":"snow-tire-filled.svg","snowTire":"snow-tire.svg","socialFacebook":"social-facebook.svg","socialLinkedin":"social-linkedin.svg","socialTwitter":"social-twitter.svg","socialWhatsapp":"social-whatsapp.svg","starFilled":"star-filled.svg","starHalfFilled":"star-half-filled.svg","starHalf":"star-half.svg","star":"star.svg","starsFilled":"stars-filled.svg","stars":"stars.svg","subwayFilled":"subway-filled.svg","subway":"subway.svg","suitcaseFilled":"suitcase-filled.svg","suitcase":"suitcase.svg","supportFilled":"support-filled.svg","support":"support.svg","suvFilled":"suv-filled.svg","suv":"suv.svg","syncFilled":"sync-filled.svg","sync":"sync.svg","synch":"synch.svg","tagFilled":"tag-filled.svg","tag":"tag.svg","tiktok":"tiktok.svg","timeAlert":"time-alert.svg","timeBackwards":"time-backwards.svg","timeCalendar":"time-calendar.svg","timeForward":"time-forward.svg","tollsFilled":"tolls-filled.svg","tolls":"tolls.svg","trailer":"trailer.svg","trainFilled":"train-filled.svg","train":"train.svg","transmissionFilled":"transmission-filled.svg","transmission":"transmission.svg","triangleDown":"triangle-down.svg","triangleRight":"triangle-right.svg","triangleUp":"triangle-up.svg","twitter":"twitter.svg","twoPeopleFilled":"two-people-filled.svg","twoPeople":"two-people.svg","uber":"uber.svg","unfoldFilled":"unfold-filled.svg","unfold":"unfold.svg","unlockedFilled":"unlocked-filled.svg","unlocked":"unlocked.svg","usbChargingPortFilled":"usb-charging-port-filled.svg","usbChargingPort":"usb-charging-port.svg","userCheckFilled":"user-check-filled.svg","userCheck":"user-check.svg","userFilled":"user-filled.svg","userQuestionFilled":"user-question-filled.svg","userQuestion":"user-question.svg","userShieldFilled":"user-shield-filled.svg","userShield":"user-shield.svg","userSwitchFilled":"user-switch-filled.svg","userSwitch":"user-switch.svg","user":"user.svg","utilityVanLargeFilled":"utility-van-large-filled.svg","utilityVanLarge":"utility-van-large.svg","utilityVanMediumFilled":"utility-van-medium-filled.svg","utilityVanMedium":"utility-van-medium.svg","utilityVanSmallFilled":"utility-van-small-filled.svg","utilityVanSmall":"utility-van-small.svg","verifiedSeal":"verified-seal.svg","videoFilled":"video-filled.svg","video":"video.svg","walkFilled":"walk-filled.svg","walk":"walk.svg","walletFilled":"wallet-filled.svg","wallet":"wallet.svg","warningCircleFilled":"warning-circle-filled.svg","warningCircle":"warning-circle.svg","warning":"warning.svg","weightFilled":"weight-filled.svg","weight":"weight.svg","whatsapp":"whatsapp.svg","wheelFilled":"wheel-filled.svg","wheel":"wheel.svg","wheelchairFilled":"wheelchair-filled.svg","wheelchair":"wheelchair.svg","wrenchFilled":"wrench-filled.svg","wrench":"wrench.svg","yingyangFilled":"yingyang-filled.svg","yingyang":"yingyang.svg","youtube":"youtube.svg"};
export default {
  "icons": {
    "accountDetailsFilled": "account-details-filled.svg",
    "accountDetails": "account-details.svg",
    "addPictureFilled": "add-picture-filled.svg",
    "addPicture": "add-picture.svg",
    "airConditioningFilled": "air-conditioning-filled.svg",
    "airConditioning": "air-conditioning.svg",
    "airportFilled": "airport-filled.svg",
    "airport": "airport.svg",
    "androidFilled": "android-filled.svg",
    "android": "android.svg",
    "antiqueFilled": "antique-filled.svg",
    "antique": "antique.svg",
    "arrowLeftCircleFilled": "arrow-left-circle-filled.svg",
    "arrowLeftCircle": "arrow-left-circle.svg",
    "arrowLeftFilled": "arrow-left-filled.svg",
    "arrowLeft": "arrow-left.svg",
    "arrowRightCircleFilled": "arrow-right-circle-filled.svg",
    "arrowRightCircle": "arrow-right-circle.svg",
    "arrowRightFilled": "arrow-right-filled.svg",
    "arrowRight": "arrow-right.svg",
    "audioInputFilled": "audio-input-filled.svg",
    "audioInput": "audio-input.svg",
    "babySeatFilled": "baby-seat-filled.svg",
    "babySeat": "baby-seat.svg",
    "backupCameraFilled": "backup-camera-filled.svg",
    "backupCamera": "backup-camera.svg",
    "bankFilled": "bank-filled.svg",
    "bank": "bank.svg",
    "batteryFilled": "battery-filled.svg",
    "battery": "battery.svg",
    "bedFilled": "bed-filled.svg",
    "bed": "bed.svg",
    "bellFilled": "bell-filled.svg",
    "bell": "bell.svg",
    "bikeRackFilled": "bike-rack-filled.svg",
    "bikeRack": "bike-rack.svg",
    "binFilled": "bin-filled.svg",
    "bin": "bin.svg",
    "bluetoothFilled": "bluetooth-filled.svg",
    "bluetooth": "bluetooth.svg",
    "briefcase": "briefcase.svg",
    "bulbFilled": "bulb-filled.svg",
    "bulb": "bulb.svg",
    "cableFilled": "cable-filled.svg",
    "cable": "cable.svg",
    "cabrioletFilled": "cabriolet-filled.svg",
    "cabriolet": "cabriolet.svg",
    "calendarCheckFilled": "calendar-check-filled.svg",
    "calendarCheck": "calendar-check.svg",
    "calendarClockFilled": "calendar-clock-filled.svg",
    "calendarClock": "calendar-clock.svg",
    "calendarDeleteFilled": "calendar-delete-filled.svg",
    "calendarDelete": "calendar-delete.svg",
    "calendarEndFilled": "calendar-end-filled.svg",
    "calendarEnd": "calendar-end.svg",
    "calendarFilled": "calendar-filled.svg",
    "calendarStartFilled": "calendar-start-filled.svg",
    "calendarStart": "calendar-start.svg",
    "calendar": "calendar.svg",
    "cameraAddFilled": "camera-add-filled.svg",
    "cameraAdd": "camera-add.svg",
    "cameraFilled": "camera-filled.svg",
    "camera": "camera.svg",
    "campervanFilled": "campervan-filled.svg",
    "campervan": "campervan.svg",
    "capacityFilled": "capacity-filled.svg",
    "capacity": "capacity.svg",
    "carAddFilled": "car-add-filled.svg",
    "carAdd": "car-add.svg",
    "carCheckFilled": "car-check-filled.svg",
    "carCheck": "car-check.svg",
    "carDamagesFilled": "car-damages-filled.svg",
    "carDamages": "car-damages.svg",
    "carDeleteFilled": "car-delete-filled.svg",
    "carDelete": "car-delete.svg",
    "carDrivyOpen": "car-drivy-open.svg",
    "carFilled": "car-filled.svg",
    "carGroupFilled": "car-group-filled.svg",
    "carGroup": "car-group.svg",
    "carLockFilled": "car-lock-filled.svg",
    "carLock": "car-lock.svg",
    "carPlayFilled": "car-play-filled.svg",
    "carPlay": "car-play.svg",
    "carReturnFilled": "car-return-filled.svg",
    "carReturn": "car-return.svg",
    "carSearch": "car-search.svg",
    "carTypeAntique": "car-type-antique.svg",
    "carTypeCabriolet": "car-type-cabriolet.svg",
    "carTypeCampervan": "car-type-campervan.svg",
    "carTypeCity": "car-type-city.svg",
    "carTypeConvertible": "car-type-convertible.svg",
    "carTypeCoupe": "car-type-coupe.svg",
    "carTypeFamily": "car-type-family.svg",
    "carTypeFourFour": "car-type-four-four.svg",
    "carTypeMinibus": "car-type-minibus.svg",
    "carTypeSedan": "car-type-sedan.svg",
    "carTypeUtility": "car-type-utility.svg",
    "car": "car.svg",
    "cardFilled": "card-filled.svg",
    "card": "card.svg",
    "cdPlayerFilled": "cd-player-filled.svg",
    "cdPlayer": "cd-player.svg",
    "certificateFilled": "certificate-filled.svg",
    "certificate": "certificate.svg",
    "chainsFilled": "chains-filled.svg",
    "chains": "chains.svg",
    "checkCircleFilled": "check-circle-filled.svg",
    "checkCircle": "check-circle.svg",
    "checkFilled": "check-filled.svg",
    "check": "check.svg",
    "checklistFilled": "checklist-filled.svg",
    "checklist": "checklist.svg",
    "chevronDownFilled": "chevron-down-filled.svg",
    "chevronDown": "chevron-down.svg",
    "chevronLeftFilled": "chevron-left-filled.svg",
    "chevronLeft": "chevron-left.svg",
    "chevronRightFilled": "chevron-right-filled.svg",
    "chevronRight": "chevron-right.svg",
    "chevronUpFilled": "chevron-up-filled.svg",
    "chevronUp": "chevron-up.svg",
    "circledArrowLeft": "circled-arrow-left.svg",
    "circledArrowRight": "circled-arrow-right.svg",
    "cityFilled": "city-filled.svg",
    "city": "city.svg",
    "cleaningFilled": "cleaning-filled.svg",
    "cleaning": "cleaning.svg",
    "clockAlertFilled": "clock-alert-filled.svg",
    "clockAlert": "clock-alert.svg",
    "clockBackwardsFilled": "clock-backwards-filled.svg",
    "clockBackwards": "clock-backwards.svg",
    "clockFilled": "clock-filled.svg",
    "clockForwardsFilled": "clock-forwards-filled.svg",
    "clockForwards": "clock-forwards.svg",
    "clock": "clock.svg",
    "closeCircleFilled": "close-circle-filled.svg",
    "closeCircle": "close-circle.svg",
    "closeFilled": "close-filled.svg",
    "close": "close.svg",
    "collapseFilled": "collapse-filled.svg",
    "collapse": "collapse.svg",
    "connectBoxFilled": "connect-box-filled.svg",
    "connectBox": "connect-box.svg",
    "connectCarFilled": "connect-car-filled.svg",
    "connectCar": "connect-car.svg",
    "contactMail": "contact-mail.svg",
    "contactPhone": "contact-phone.svg",
    "contextualPaperclip": "contextual-paperclip.svg",
    "contextualQuestion": "contextual-question.svg",
    "contextualWarningCircleFilled": "contextual-warning-circle-filled.svg",
    "contextualWarningCircle": "contextual-warning-circle.svg",
    "contract": "contract.svg",
    "convertibleFilled": "convertible-filled.svg",
    "convertible": "convertible.svg",
    "copyFilled": "copy-filled.svg",
    "copy": "copy.svg",
    "coupeFilled": "coupe-filled.svg",
    "coupe": "coupe.svg",
    "creditCardAddFilled": "credit-card-add-filled.svg",
    "creditCardAdd": "credit-card-add.svg",
    "creditCardErrorFilled": "credit-card-error-filled.svg",
    "creditCardError": "credit-card-error.svg",
    "creditCardFilled": "credit-card-filled.svg",
    "creditCard": "credit-card.svg",
    "crosshover": "crosshover.svg",
    "crossoverFilled": "crossover-filled.svg",
    "crossover": "crossover.svg",
    "cruiseControlFilled": "cruise-control-filled.svg",
    "cruiseControl": "cruise-control.svg",
    "currencyFilled": "currency-filled.svg",
    "currency": "currency.svg",
    "dashcamFilled": "dashcam-filled.svg",
    "dashcam": "dashcam.svg",
    "diamondFilled": "diamond-filled.svg",
    "diamond": "diamond.svg",
    "directionsFilled": "directions-filled.svg",
    "directions": "directions.svg",
    "document": "document.svg",
    "dotHorizontalFilled": "dot-horizontal-filled.svg",
    "dotHorizontal": "dot-horizontal.svg",
    "dotVerticalFilled": "dot-vertical-filled.svg",
    "dotVertical": "dot-vertical.svg",
    "dotsHorizontal": "dots-horizontal.svg",
    "dotsVertical": "dots-vertical.svg",
    "downloadFilled": "download-filled.svg",
    "download": "download.svg",
    "earningFilled": "earning-filled.svg",
    "earning": "earning.svg",
    "earthFilled": "earth-filled.svg",
    "earth": "earth.svg",
    "edit": "edit.svg",
    "electricFilled": "electric-filled.svg",
    "electric": "electric.svg",
    "evBatteryFilled": "ev-battery-filled.svg",
    "evBattery": "ev-battery.svg",
    "evCableFilled": "ev-cable-filled.svg",
    "evCable": "ev-cable.svg",
    "evChargerFilled": "ev-charger-filled.svg",
    "evCharger": "ev-charger.svg",
    "expandFilled": "expand-filled.svg",
    "expand": "expand.svg",
    "externalLinkFilled": "external-link-filled.svg",
    "externalLink": "external-link.svg",
    "eyeClosedFilled": "eye-closed-filled.svg",
    "eyeClosed": "eye-closed.svg",
    "eyeOpenedFilled": "eye-opened-filled.svg",
    "eyeOpened": "eye-opened.svg",
    "eye": "eye.svg",
    "faceRecognitionFilled": "face-recognition-filled.svg",
    "faceRecognition": "face-recognition.svg",
    "facebook": "facebook.svg",
    "familyFilled": "family-filled.svg",
    "family": "family.svg",
    "fileFilled": "file-filled.svg",
    "file": "file.svg",
    "filepdfFilled": "filepdf-filled.svg",
    "filepdf": "filepdf.svg",
    "filexlsFilled": "filexls-filled.svg",
    "filexls": "filexls.svg",
    "filterFilled": "filter-filled.svg",
    "filter": "filter.svg",
    "filters": "filters.svg",
    "fireFilled": "fire-filled.svg",
    "fire": "fire.svg",
    "flagFilled": "flag-filled.svg",
    "flag": "flag.svg",
    "fourByFourFilled": "four-by-four-filled.svg",
    "fourByFour": "four-by-four.svg",
    "fourWheelDriveFilled": "four-wheel-drive-filled.svg",
    "fourWheelDrive": "four-wheel-drive.svg",
    "fuelTankFilled": "fuel-tank-filled.svg",
    "fuelTank": "fuel-tank.svg",
    "geolocation": "geolocation.svg",
    "giftFilled": "gift-filled.svg",
    "gift": "gift.svg",
    "gpsFilled": "gps-filled.svg",
    "gps": "gps.svg",
    "graphUpFilled": "graph-up-filled.svg",
    "graphUp": "graph-up.svg",
    "handDollarFilled": "hand-dollar-filled.svg",
    "handDollar": "hand-dollar.svg",
    "healingFilled": "healing-filled.svg",
    "healing": "healing.svg",
    "heartFilled": "heart-filled.svg",
    "heart": "heart.svg",
    "heightFilled": "height-filled.svg",
    "height": "height.svg",
    "hitchFilled": "hitch-filled.svg",
    "hitch": "hitch.svg",
    "homeFilled": "home-filled.svg",
    "home": "home.svg",
    "idCardFilled": "id-card-filled.svg",
    "idCard": "id-card.svg",
    "incidentFilled": "incident-filled.svg",
    "incident": "incident.svg",
    "infoCircleFilled": "info-circle-filled.svg",
    "infoCircle": "info-circle.svg",
    "infoFilled": "info-filled.svg",
    "info": "info.svg",
    "instagram": "instagram.svg",
    "instantFilled": "instant-filled.svg",
    "instant": "instant.svg",
    "invoiceFilled": "invoice-filled.svg",
    "invoice": "invoice.svg",
    "keyConnectFilled": "key-connect-filled.svg",
    "keyConnect": "key-connect.svg",
    "keyFilled": "key-filled.svg",
    "key": "key.svg",
    "licenceCheckFilled": "licence-check-filled.svg",
    "licenceCheck": "licence-check.svg",
    "licenceFilled": "licence-filled.svg",
    "licencePaperFilled": "licence-paper-filled.svg",
    "licencePaper": "licence-paper.svg",
    "licence": "licence.svg",
    "lifeBuoyFilled": "life-buoy-filled.svg",
    "lifeBuoy": "life-buoy.svg",
    "linkedin": "linkedin.svg",
    "loading": "loading.svg",
    "localityFilled": "locality-filled.svg",
    "locality": "locality.svg",
    "locationFilled": "location-filled.svg",
    "locationMap": "location-map.svg",
    "locationParking": "location-parking.svg",
    "locationPin": "location-pin.svg",
    "location": "location.svg",
    "lockCheckFilled": "lock-check-filled.svg",
    "lockCheck": "lock-check.svg",
    "lockedFilled": "locked-filled.svg",
    "locked": "locked.svg",
    "loginFilled": "login-filled.svg",
    "login": "login.svg",
    "logoutFilled": "logout-filled.svg",
    "logout": "logout.svg",
    "lookFilled": "look-filled.svg",
    "look": "look.svg",
    "mailCheckFilled": "mail-check-filled.svg",
    "mailCheck": "mail-check.svg",
    "mailFilled": "mail-filled.svg",
    "mail": "mail.svg",
    "mapAltFilled": "map-alt-filled.svg",
    "mapAlt": "map-alt.svg",
    "mapFilled": "map-filled.svg",
    "map": "map.svg",
    "meetDriverFilled": "meet-driver-filled.svg",
    "meetDriver": "meet-driver.svg",
    "meetOwnerFilled": "meet-owner-filled.svg",
    "meetOwner": "meet-owner.svg",
    "menuListFilled": "menu-list-filled.svg",
    "menuList": "menu-list.svg",
    "messagesFilled": "messages-filled.svg",
    "messages": "messages.svg",
    "mileageFilled": "mileage-filled.svg",
    "mileage": "mileage.svg",
    "minibusFilled": "minibus-filled.svg",
    "minibus": "minibus.svg",
    "minusCircleFilled": "minus-circle-filled.svg",
    "minusCircle": "minus-circle.svg",
    "minusFilled": "minus-filled.svg",
    "minus": "minus.svg",
    "miscGift": "misc-gift.svg",
    "moonFilled": "moon-filled.svg",
    "moon": "moon.svg",
    "nearbyDeviceFilled": "nearby-device-filled.svg",
    "nearbyDevice": "nearby-device.svg",
    "notification": "notification.svg",
    "number1CircleFilled": "number-1-circle-filled.svg",
    "number1Circle": "number-1-circle.svg",
    "number2CircleFilled": "number-2-circle-filled.svg",
    "number2Circle": "number-2-circle.svg",
    "number3CircleFilled": "number-3-circle-filled.svg",
    "number3Circle": "number-3-circle.svg",
    "number4CircleFilled": "number-4-circle-filled.svg",
    "number4Circle": "number-4-circle.svg",
    "number5CircleFilled": "number-5-circle-filled.svg",
    "number5Circle": "number-5-circle.svg",
    "okHandFilled": "ok-hand-filled.svg",
    "okHand": "ok-hand.svg",
    "optionAirConditioning": "option-air-conditioning.svg",
    "optionAndroidAuto": "option-android-auto.svg",
    "optionAppleCarplay": "option-apple-carplay.svg",
    "optionAudioInput": "option-audio-input.svg",
    "optionBabySeat": "option-baby-seat.svg",
    "optionBikeRack": "option-bike-rack.svg",
    "optionBluetoothAudio": "option-bluetooth-audio.svg",
    "optionCdPlayer": "option-cd-player.svg",
    "optionChains": "option-chains.svg",
    "optionCruiseControl": "option-cruise-control.svg",
    "optionDashcam": "option-dashcam.svg",
    "optionGps": "option-gps.svg",
    "optionHasTrailer": "option-has-trailer.svg",
    "optionHitch": "option-hitch.svg",
    "optionRoofBox": "option-roof-box.svg",
    "optionSkiRack": "option-ski-rack.svg",
    "optionSnowTire": "option-snow-tire.svg",
    "optionWheelchairAccessible": "option-wheelchair-accessible.svg",
    "paperclipFilled": "paperclip-filled.svg",
    "paperclip": "paperclip.svg",
    "parkingFilled": "parking-filled.svg",
    "parking": "parking.svg",
    "partyFilled": "party-filled.svg",
    "party": "party.svg",
    "passportFilled": "passport-filled.svg",
    "passport": "passport.svg",
    "paymentsFilled": "payments-filled.svg",
    "payments": "payments.svg",
    "pencilFilled": "pencil-filled.svg",
    "pencil": "pencil.svg",
    "peopleUser": "people-user.svg",
    "percentageFilled": "percentage-filled.svg",
    "percentage": "percentage.svg",
    "performanceFilled": "performance-filled.svg",
    "performance": "performance.svg",
    "phoneFilled": "phone-filled.svg",
    "phoneLinkFilled": "phone-link-filled.svg",
    "phoneLink": "phone-link.svg",
    "phone": "phone.svg",
    "photosFilled": "photos-filled.svg",
    "photos": "photos.svg",
    "pickupTruckFilled": "pickup-truck-filled.svg",
    "pickupTruck": "pickup-truck.svg",
    "pigFilled": "pig-filled.svg",
    "pig": "pig.svg",
    "pinFilled": "pin-filled.svg",
    "pin": "pin.svg",
    "plug": "plug.svg",
    "plusCircleFilled": "plus-circle-filled.svg",
    "plusCircle": "plus-circle.svg",
    "plusFilled": "plus-filled.svg",
    "plus": "plus.svg",
    "positionFilled": "position-filled.svg",
    "position": "position.svg",
    "pricingFlatFilled": "pricing-flat-filled.svg",
    "pricingFlat": "pricing-flat.svg",
    "pricingVariableFilled": "pricing-variable-filled.svg",
    "pricingVariable": "pricing-variable.svg",
    "proFilled": "pro-filled.svg",
    "pro": "pro.svg",
    "profilePictureFilled": "profile-picture-filled.svg",
    "profilePicture": "profile-picture.svg",
    "questionCircleFilled": "question-circle-filled.svg",
    "questionCircle": "question-circle.svg",
    "question": "question.svg",
    "raceFlagFilled": "race-flag-filled.svg",
    "raceFlag": "race-flag.svg",
    "radioTuneFilled": "radio-tune-filled.svg",
    "radioTune": "radio-tune.svg",
    "recenterFilled": "recenter-filled.svg",
    "recenter": "recenter.svg",
    "refreshFilled": "refresh-filled.svg",
    "refresh": "refresh.svg",
    "reorderFilled": "reorder-filled.svg",
    "reorder": "reorder.svg",
    "replacementCarFilled": "replacement-car-filled.svg",
    "replacementCar": "replacement-car.svg",
    "replyFilled": "reply-filled.svg",
    "reply": "reply.svg",
    "reset": "reset.svg",
    "rideFilled": "ride-filled.svg",
    "ride": "ride.svg",
    "roadFilled": "road-filled.svg",
    "road": "road.svg",
    "roadsideAssistanceFilled": "roadside-assistance-filled.svg",
    "roadsideAssistance": "roadside-assistance.svg",
    "roofBoxFilled": "roof-box-filled.svg",
    "roofBox": "roof-box.svg",
    "rotateFilled": "rotate-filled.svg",
    "rotate": "rotate.svg",
    "sealCheckFilled": "seal-check-filled.svg",
    "sealCheck": "seal-check.svg",
    "searchCarFilled": "search-car-filled.svg",
    "searchCar": "search-car.svg",
    "searchFilled": "search-filled.svg",
    "searchPeopleFilled": "search-people-filled.svg",
    "searchPeople": "search-people.svg",
    "search": "search.svg",
    "seatbeltFilled": "seatbelt-filled.svg",
    "seatbelt": "seatbelt.svg",
    "sedanFilled": "sedan-filled.svg",
    "sedan": "sedan.svg",
    "sendFilled": "send-filled.svg",
    "send": "send.svg",
    "serviceBattery": "service-battery.svg",
    "serviceCleaning": "service-cleaning.svg",
    "serviceFuel": "service-fuel.svg",
    "serviceHealing": "service-healing.svg",
    "serviceLockedFilled": "service-locked-filled.svg",
    "serviceLocked": "service-locked.svg",
    "serviceTolls": "service-tolls.svg",
    "serviceUnlocked": "service-unlocked.svg",
    "settingsFilled": "settings-filled.svg",
    "settings": "settings.svg",
    "shareAndroidFilled": "share-android-filled.svg",
    "shareAndroid": "share-android.svg",
    "shareIosFilled": "share-ios-filled.svg",
    "shareIos": "share-ios.svg",
    "share": "share.svg",
    "shieldCheckFilled": "shield-check-filled.svg",
    "shieldCheck": "shield-check.svg",
    "shieldFilled": "shield-filled.svg",
    "shield": "shield.svg",
    "shopFilled": "shop-filled.svg",
    "shop": "shop.svg",
    "skiRackFilled": "ski-rack-filled.svg",
    "skiRack": "ski-rack.svg",
    "sliderFilled": "slider-filled.svg",
    "slider": "slider.svg",
    "smartphoneFilled": "smartphone-filled.svg",
    "smartphone": "smartphone.svg",
    "smilingFaceFilled": "smiling-face-filled.svg",
    "smilingFace": "smiling-face.svg",
    "snowTireFilled": "snow-tire-filled.svg",
    "snowTire": "snow-tire.svg",
    "socialFacebook": "social-facebook.svg",
    "socialLinkedin": "social-linkedin.svg",
    "socialTwitter": "social-twitter.svg",
    "socialWhatsapp": "social-whatsapp.svg",
    "starFilled": "star-filled.svg",
    "starHalfFilled": "star-half-filled.svg",
    "starHalf": "star-half.svg",
    "star": "star.svg",
    "starsFilled": "stars-filled.svg",
    "stars": "stars.svg",
    "subwayFilled": "subway-filled.svg",
    "subway": "subway.svg",
    "suitcaseFilled": "suitcase-filled.svg",
    "suitcase": "suitcase.svg",
    "supportFilled": "support-filled.svg",
    "support": "support.svg",
    "suvFilled": "suv-filled.svg",
    "suv": "suv.svg",
    "syncFilled": "sync-filled.svg",
    "sync": "sync.svg",
    "synch": "synch.svg",
    "tagFilled": "tag-filled.svg",
    "tag": "tag.svg",
    "tiktok": "tiktok.svg",
    "timeAlert": "time-alert.svg",
    "timeBackwards": "time-backwards.svg",
    "timeCalendar": "time-calendar.svg",
    "timeForward": "time-forward.svg",
    "tollsFilled": "tolls-filled.svg",
    "tolls": "tolls.svg",
    "trailer": "trailer.svg",
    "trainFilled": "train-filled.svg",
    "train": "train.svg",
    "transmissionFilled": "transmission-filled.svg",
    "transmission": "transmission.svg",
    "triangleDown": "triangle-down.svg",
    "triangleRight": "triangle-right.svg",
    "triangleUp": "triangle-up.svg",
    "twitter": "twitter.svg",
    "twoPeopleFilled": "two-people-filled.svg",
    "twoPeople": "two-people.svg",
    "uber": "uber.svg",
    "unfoldFilled": "unfold-filled.svg",
    "unfold": "unfold.svg",
    "unlockedFilled": "unlocked-filled.svg",
    "unlocked": "unlocked.svg",
    "usbChargingPortFilled": "usb-charging-port-filled.svg",
    "usbChargingPort": "usb-charging-port.svg",
    "userCheckFilled": "user-check-filled.svg",
    "userCheck": "user-check.svg",
    "userFilled": "user-filled.svg",
    "userQuestionFilled": "user-question-filled.svg",
    "userQuestion": "user-question.svg",
    "userShieldFilled": "user-shield-filled.svg",
    "userShield": "user-shield.svg",
    "userSwitchFilled": "user-switch-filled.svg",
    "userSwitch": "user-switch.svg",
    "user": "user.svg",
    "utilityVanLargeFilled": "utility-van-large-filled.svg",
    "utilityVanLarge": "utility-van-large.svg",
    "utilityVanMediumFilled": "utility-van-medium-filled.svg",
    "utilityVanMedium": "utility-van-medium.svg",
    "utilityVanSmallFilled": "utility-van-small-filled.svg",
    "utilityVanSmall": "utility-van-small.svg",
    "verifiedSeal": "verified-seal.svg",
    "videoFilled": "video-filled.svg",
    "video": "video.svg",
    "walkFilled": "walk-filled.svg",
    "walk": "walk.svg",
    "walletFilled": "wallet-filled.svg",
    "wallet": "wallet.svg",
    "warningCircleFilled": "warning-circle-filled.svg",
    "warningCircle": "warning-circle.svg",
    "warning": "warning.svg",
    "weightFilled": "weight-filled.svg",
    "weight": "weight.svg",
    "whatsapp": "whatsapp.svg",
    "wheelFilled": "wheel-filled.svg",
    "wheel": "wheel.svg",
    "wheelchairFilled": "wheelchair-filled.svg",
    "wheelchair": "wheelchair.svg",
    "wrenchFilled": "wrench-filled.svg",
    "wrench": "wrench.svg",
    "yingyangFilled": "yingyang-filled.svg",
    "yingyang": "yingyang.svg",
    "youtube": "youtube.svg"
  }
}
;